import { initialArticleState, ArticleState } from 'mk2/apps/blogs/containers/Article/Article.reducers';
import { AppState } from 'mk2/reducers';

export const getArticleState = (state: AppState, username: string, articleSlug: string, fromShared: boolean): ArticleState => {
  if (fromShared) {
      return (state.containers.blogs.shared.blogArticles && state.containers.blogs.shared.blogArticles[`${username}/${articleSlug}`]) || initialArticleState;
  } else {
      return (state.containers.blogs.blogsArticles && state.containers.blogs.blogsArticles[`${username}/${articleSlug}`]) || initialArticleState;
  }

};
